/**
 * The tabs across the console's Operations pages: the go-live checklist, then
 * each runbook document. One list, built from RUNBOOK_DOCS, so the checklist
 * page and the runbook page cannot name the documents differently.
 */
import { TabLinks } from '../../shared/Tabs';
import { RUNBOOK_DOCS } from './runbookDocs';

export function OperationsTabs() {
  return (
    <TabLinks
      label="Runbook documents"
      items={[
        // The checklist first: it is what somebody running a go-live wants,
        // and these documents are what it points at.
        { to: '/console/operations/go-live', label: 'Go-live checklist' },
        ...RUNBOOK_DOCS.map((d) => ({ to: `/console/operations/${d.id}`, label: d.label })),
      ]}
    />
  );
}
